import React, {useEffect, useRef, useState} from "react";
import {InputText} from "primereact/inputtext";
import {InputTextarea} from "primereact/inputtextarea";
import {Dropdown} from "primereact/dropdown";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {classNames} from "primereact/utils";
import {setIVRConfigurationField} from "../../../../redux/actions/actionsIVRConfiguration";
import {activateDeactivateIVRConfiguration} from "../../../../redux/api/apiIVRConfiguration";
import {InputSwitch} from "primereact/inputswitch";
import {Divider} from "primereact/divider";
import {getUsersManagerUserBranchesData} from "../../../../redux/api/apiUsersList";

const IVRConfigurationDialogGeneralSettings = () => {
    const dispatch = useAppDispatch();
    const ivrConfigurationData = useAppSelector(state => state.IVRConfigurationReducer.ivrConfigurationData?.configuration);
    const errorFields = useAppSelector(state => state.IVRConfigurationReducer.errorFields);
    const nameField = useRef(null);
    const editType = useAppSelector(state => state.UsersReducer.editType);
    const jwtToken = useAppSelector(state => state.UsersReducer.userData.jwtToken);
    const branches = useAppSelector(state => state.UsersListReducer.branches);
    const [isActiveToggling, setIsActiveToggling] = useState(false);

    const scrollIntoNameView = () => {
        // @ts-ignore
        nameField?.current?.scrollIntoView({behavior: 'smooth'});
    }

    useEffect(() => {
        if (!ivrConfigurationData.name && errorFields?.name) {
            scrollIntoNameView();
        }
    }, [errorFields, ivrConfigurationData]);

    useEffect(() => {
        dispatch(getUsersManagerUserBranchesData(jwtToken?.jwtToken));
    }, []);

    return (
        <div className="general-settings">
            <div className="grid p-fluid">
                <div className="field col-12 md:col-6" ref={nameField}>
                    <label htmlFor="name" className={classNames('', {'p-error': errorFields?.name})}>Назва *</label>
                    <InputText
                        id="name"
                        value={ivrConfigurationData?.name || ''}
                        maxLength={150}
                        className={classNames('', {'p-invalid': errorFields?.name})}
                        onChange={e => {
                            dispatch(setIVRConfigurationField({fieldName: 'name', value: e.target.value}));
                        }}
                        disabled={!editType}
                    />
                    {errorFields?.name && <div className="col-12 md:col-12 pt-2 px-0 pb-0"><span className="title p-error text-sm">{errorFields?.name?.name || (typeof errorFields?.name === 'string' ? errorFields?.name : '')}</span></div>}
                </div>
                <div className="field col-12 md:col-3 m-0 p-0">
                </div>
                <div className="field col-12 md:col-6">
                    <label htmlFor="description">Опис</label>
                    <InputTextarea
                        id="description"
                        value={ivrConfigurationData?.description || ''}
                        onChange={e => {
                            dispatch(setIVRConfigurationField({fieldName: 'description', value: e.target.value}));
                        }}
                        autoResize
                        rows={3}
                        maxLength={500}
                        disabled={!editType}
                    />
                </div>
                <Divider className="mx-2"/>
                <div className="field col-12 md:col-4">
                    <label
                        htmlFor="branchId"
                        className={classNames('', {'p-error': errorFields?.branchId && !ivrConfigurationData?.branchId})}
                    >
                        Бранч *
                    </label>
                    <Dropdown
                        id="branchId"
                        value={ivrConfigurationData?.branchId || ''}
                        options={branches}
                        filter
                        className={classNames('w-full', {'p-invalid': errorFields?.branchId && !ivrConfigurationData?.branchId})}
                        optionValue="id"
                        optionLabel="name"
                        placeholder='Виберіть бранч'
                        onChange={e => {
                            dispatch(setIVRConfigurationField({fieldName: 'branchId', value: e.value}));
                        }}
                        disabled={!editType}
                    />
                </div>
                <Divider className="mx-2"/>
                <div className="field col-12 md:col-12">
                    <label htmlFor="isActive" className="pl-2">Стан</label>
                    <div className="field-radiobutton my-4 pl-1">
                        <label htmlFor="isActive" className="mr-2 w-6rem">Не активна</label>
                        <InputSwitch
                            disabled={!editType || isActiveToggling}
                            className="mr-3"
                            checked={ivrConfigurationData?.isActive || false}
                            onChange={(e) => {
                                const next = e.value;
                                const flowId = ivrConfigurationData?.flowId;
                                if (
                                    flowId == null ||
                                    flowId === "" ||
                                    Number.isNaN(Number(flowId))
                                ) {
                                    dispatch(
                                        setIVRConfigurationField({
                                            fieldName: "isActive",
                                            value: next,
                                        })
                                    );
                                    return;
                                }
                                setIsActiveToggling(true);
                                void (
                                    dispatch(
                                        activateDeactivateIVRConfiguration(
                                            Number(flowId),
                                            next,
                                            jwtToken?.jwtToken
                                        )
                                    ) as Promise<boolean>
                                ).finally(() => setIsActiveToggling(false));
                            }}
                        />
                        <label htmlFor="isActive">Активна</label>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default IVRConfigurationDialogGeneralSettings;

